// import { Injectable } from '@angular/core'
// import { Subject } from 'rxjs'

// @Injectable({
//   providedIn: 'root'
// })
// export class ApiCancelService {
//   private cancelSubject = new Subject<void>()

//   private _isLoggingOut = false

//   readonly cancelPending$ = this.cancelSubject.asObservable()

//   get isLoggingOut(): boolean {
//     return this._isLoggingOut
//   }

//   startLogout() {
//     this._isLoggingOut = true
//     this.cancelSubject.next()
//   }

//   resetLogout() {
//     this._isLoggingOut = false
//   }
// }

import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class ApiCancelService {
  private cancelSubject = new Subject<void>()

  private _isLoggingOut = false
  private _isLogoutApiCall = false

  readonly cancelPending$ = this.cancelSubject.asObservable()

  get isLoggingOut(): boolean {
    return this._isLoggingOut
  }

  get isLogoutApiCall(): boolean {
    return this._isLogoutApiCall
  }

  startLogoutApi() {
    this._isLogoutApiCall = true
  }

  endLogoutApi() {
    this._isLogoutApiCall = false
  }

  startLogout() {
    this._isLoggingOut = true
    this.cancelSubject.next()
  }

  resetLogout() {
    this._isLoggingOut = false
    this._isLogoutApiCall = false
  }
}
